"use client";
import Image from "next/image";
import { FaQuoteLeft } from "react-icons/fa6";
import StarRating from "src/components/atoms/StarRating";
import React, { useEffect, useRef, useState } from "react";

export default function ReviewCard({ review, index }) {
  const glowColors = ["rgba(168,85,247,0.95)", "rgba(59,130,246,0.95)", "rgba(6,182,212,0.95)", "rgba(236,72,153,0.95)"];

  const textRef = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    if (textRef.current) {
      setShowButton(textRef.current.scrollHeight > textRef.current.clientHeight);
    }
  }, []);

  return (
    <div className="tr-card" style={{ "--glow": glowColors[index % glowColors.length] }}>
      <div className="tr-top-line" />
      <div className="tr-bottom-line" />

      <div className="tr-card-top">
        <div className="tr-quote">
          <FaQuoteLeft size={20} />
        </div>

        <div className="tr-rating-row">
          <StarRating rating={review.rating} />
        </div>

        <p ref={textRef} className={`tr-text ${expanded ? "expanded" : ""}`}>
          {review.text}
        </p>

        {showButton && (
          <button className="tr-see-more" onClick={() => setExpanded(!expanded)}>
            {expanded ? "See Less" : "See More"}
          </button>
        )}
      </div>

      <div className="tr-card-bottom">
        <div className="tr-rule" />
        <div className="tr-footer">
          <div className="tr-user">
            <div className="tr-avatar flex justify-center items-center">
              {review.image ? (
                <Image src={review.image} alt={review.name || "Reviewer"} width={48} height={48} className="w-full h-full object-contain rounded-full" />
              ) : (
                <span>{review.name?.charAt(0)}</span>
              )}
            </div>

            <div className="tr-meta">
              <p className="tr-name">{review.name}</p>
              <p className="tr-role">{review.role}</p>
              <p className="tr-role text-accent! font-bold!">{review.companyName}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
